import React from 'react';
import Link from 'next/link';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';

interface Links {
  links: {
    title: string;
    url: string;
  }[];
}

const LinkParagraph = (props: ParagraphProps) => {
  const model = props.paragraph.data as Links;
  const links = model.links.map(link => {
    const { title, url } = link;

    if (url.startsWith('/')) {
      return (
        <Link key={link.url} as={link.url} href="/">
          <a>{title}</a>
        </Link>
      );
    }

    return (
      <a key={link.url} href={url}>
        {title}
      </a>
    );
  });

  return <section className="paragraph link-paragraph">{links}</section>;
};

export default LinkParagraph;
